import { c, classy, m } from '@onfido/castor';
import React from 'react';
import { withRef } from '../../utils';
export const PopoverBase = withRef(function Popover({ align, className, position, ...props }, ref) {
    return (React.createElement("div", { ...props, ref: ref, className: classy(c('popover'), m(`${position}--${align}`), className) }));
});
//# sourceMappingURL=popover-base.js.map